const LEADING_SPACE_REGEX = /(^\s+)/;
const TRAILING_SPACE_REGEX = /(\s+)$/;

function filterSearch (query) {
  if (!query) {
    return '';
  }
  return query.replace(LEADING_SPACE_REGEX, '').replace(TRAILING_SPACE_REGEX, '');
}

export default filterSearch;
